define('SiteSearch.CategorySearch.View', [
    'Backbone',
    'sitesearch_categorysearch.tpl'
], function SiteSearchCategorySearchView(
    Backbone,
    siteSearchCategorySearchTpl
) {
    'use strict';

    return Backbone.View.extend({
        template: siteSearchCategorySearchTpl,
        initialize: function initialize(options) {
            this.listenTo(options.application.getLayout(), 'afterAppendView', this.render);
        },
        getContext: function getContext() {
            var category = this.options.application.getCurrentCategory(false);
            return {
                categoryName: category && category.get('name')
            };
        }
    });
});
